import React from "react";
import { Header, Image } from "semantic-ui-react";

const CampaniasHeader = () => {
  return (
    <Header as="h1" color="blue">
      <Image src="/assets/icons/oferta.svg" size="medium" /> Mis campa&ntilde;as
    </Header>
  );
};

export default CampaniasHeader;
